export default __webpack_public_path__ + "static/media/driver-dispute.22425782.svg";